export default __webpack_public_path__ + "static/media/maestro-background.9cdfc933.png";